<template>
  <div class="fund-nav-chart-chrome" :class="`is-${variant}`">
    <p v-if="resolvedTitle" class="fund-nav-chart-chrome__title">{{ resolvedTitle }}</p>
    <div class="fund-nav-chart-chrome__body">
      <div class="fund-nav-chart-chrome__chart">
        <slot />
      </div>
    </div>
    <p
      v-if="hasData && resolvedFooterLabel"
      class="fund-nav-chart-chrome__footer"
    >{{ resolvedFooterLabel }}</p>
  </div>
</template>

<script>
export default {
  name: "FundNavChartChrome",
  props: {
    title: {
      type: String,
      default: ""
    },
    footerLabel: {
      type: String,
      default: ""
    },
    hasData: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: "detail",
      validator(value) {
        return ["detail", "mini"].includes(value);
      }
    }
  },
  computed: {
    resolvedTitle() {
      return this.title || this.$t("privateFund.performanceNavTrend");
    },
    resolvedFooterLabel() {
      return this.footerLabel || this.$t("privateFund.performanceNavPeriod");
    }
  }
};
</script>

<style scoped lang="less">
.fund-nav-chart-chrome {
  width: 100%;
  overflow: visible;

  &__title {
    margin-bottom: 24px;
    color: #1353c8;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
  }

  &__body {
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  &__chart {
    flex: 1;
    min-width: 0;
    overflow: visible;
  }

  &__footer {
    margin-top: 24px;
    color: #171717;
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
  }
}

.black-theme {
  .fund-nav-chart-chrome__title {
    color: #377cfb;
  }

  .fund-nav-chart-chrome__footer {
    color: #fff;
  }
}
</style>
